import type { ISwitchButton } from '../Buttons/SwitchButton'
import type { IAppManagement } from '~/types/application-management'
import type { DeviceType } from '~/types/device-type'

import { DEVICE_TYPE } from '~/const'
import { appKeyDeviceTypeToString } from '~/utils/application'

/** @doc It takes an app, typically from the App Summary, and returns its supported device types */
export const getDeviceTypes = (app: IAppManagement | undefined): DeviceType[] => {
  if (!app) return []
  const deviceTypes = [DEVICE_TYPE.ANDROID, DEVICE_TYPE.IOS, DEVICE_TYPE.WEB]
  return deviceTypes.filter((el) => el in app)
}

/** @doc It generates a button for each element of a deviceTypes array, and shows the current device type as active */
export const getDeviceTypeSwitchButtons = ({
  appKey,
  currentDeviceType,
  deviceTypes,
}: {
  appKey: string
  currentDeviceType: DeviceType
  deviceTypes: DeviceType[]
}): ISwitchButton[] => {
  return [
    {
      application: appKeyDeviceTypeToString(appKey, DEVICE_TYPE.ANDROID),
      content: 'Android',
      id: DEVICE_TYPE.ANDROID,
      isActive: currentDeviceType === DEVICE_TYPE.ANDROID,
      isDisabled: !deviceTypes.includes(DEVICE_TYPE.ANDROID),
    },
    {
      application: appKeyDeviceTypeToString(appKey, DEVICE_TYPE.IOS),
      content: 'iOS',
      id: DEVICE_TYPE.IOS,
      isActive: currentDeviceType === DEVICE_TYPE.IOS,
      isDisabled: !deviceTypes.includes(DEVICE_TYPE.IOS),
    },
    {
      application: appKeyDeviceTypeToString(appKey, DEVICE_TYPE.WEB),
      content: 'Web',
      id: DEVICE_TYPE.WEB,
      isActive: currentDeviceType === DEVICE_TYPE.WEB,
      isDisabled: !deviceTypes.includes(DEVICE_TYPE.WEB),
    },
  ]
}
